<template>
  <div class="batches-modal">
    <div class="batches-modal-body">
      <spinner v-if="isCreatingBatch" />

      <div v-else class="batches-list">
        <template v-if="isFetchingBatches">
          <inline-batch-card-skeleton
            v-for="index in 3"
            :key="index"
          />
        </template>

        <template v-else-if="batches.length">
          <inline-batch-card
            v-for="batch in batches"
            :key="batch.id"
            :batch="batch"
            class="batches-list-item"
            @click="handleChooseBatch(batch)"
          />
        </template>

        <div
          v-else
          class="batches-list-empty"
        >
          <svg-loader
            src="/static/images/icon-empty-list.svg"
            class="batches-list-empty-icon"
          />

          <div v-if="hasFetchingErrors">
            <div class="batches-list-empty-text">
              Ocorreu um erro ao tentar buscar por lotes compatíveis.
            </div>
          </div>

          <template v-else>
            <div class="batches-list-empty-text">
              Não há lotes compatíveis. Você pode criar um novo lote (Se alguma das amostras selecionadas já estiver em um lote, ela será movida para o lote novo).
            </div>

            <md-button
              class="btn btn-primary"
              @click="handleCreateNewBatch"
            >
              Criar novo lote
            </md-button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import batchService from '@/api/batch';
import notify from '@/api/notification'

import Spinner from '@/components/common/Spinner'

import InlineBatchCard from './InlineBatchCard'
import InlineBatchCardSkeleton from './InlineBatchCardSkeleton'

export default {
  name: 'BatchSamplesBatchSelection',
  components: {
    InlineBatchCard,
    InlineBatchCardSkeleton,
    Spinner,
  },
  props: {
    sample: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['selectedSamples']),
    targetSamples() {
      return this.sample ? [this.sample] : this.selectedSamples
    }
  },
  data() {
    return {
      batches: [],
      isFetchingBatches: false,
      isCreatingBatch: false,
      hasFetchingErrors: false,
    }
  },
  mounted() {
    this.fetchBatches()
  },
  methods: {
    async handleChooseBatch(batch) {
      this.$emit('continue', batch)
    },
    async fetchBatches() {
      this.isFetchingBatches = true;
      this.hasFetchingErrors = false;

      try {
        const payload = this.targetSamples.map(sample => sample.bar_code)
        const batchesResponse = await batchService.getBatchesCompatibleWithSamples(payload)

        this.batches = batchesResponse.data ?? []
      } catch (error) {
        console.error('Error fetching compatible batches.', error)

        this.hasFetchingErrors = true;

        notify({
          title: 'Erro:',
          message: 'Ocorreu um problema inesperado ao buscar por lotes disponíveis.'
        })
      }

      this.isFetchingBatches = false
    },
    async handleCreateNewBatch() {
      this.isCreatingBatch = true;

      for await (const sample of this.targetSamples) {
        if (sample.batch_identifier) {
          if (sample.origem === 'LIS') {
            await batchService.removeSamplesFromWSBatch(
              sample.bar_code,
              sample.batch_identifier,
            );
          } else {
            await batchService.removeSamplesFromBatch(
              sample.bar_code,
              sample.batch_id,
            );
          }
        }
      }

      const payload = {
        samples: this.targetSamples.map(sample => ({
          barcode: sample.bar_code
        }))
      }

      let createdBatch;

      if (this.targetSamples.some(sample => sample.origem === 'LIS')) {
        createdBatch = await this.createWSBatch(payload);
      } else {
        createdBatch = await this.createBatch(payload);
      }

      this.isCreatingBatch = false;

      const createdBatchID = createdBatch?.id ?? createdBatch?.batchIdentifier;

      if (createdBatchID) {
        this.$router.replace(`/print-tag/batches/${createdBatchID}`);
      }
    },
    async createBatch(payload) {
      try {
        const response = await batchService.createBatch(payload);

        return response?.data;
      } catch (error) {
        console.error("Error creating batch.", error);

        notify({
          title: "Erro:",
          message: "Erro ao tentar criar novo lote.",
        });
      }
    },
    async createWSBatch(payload) {
      try {
        const response = await batchService.createWSBatch(payload);

        return response?.data;
      } catch (error) {
        console.error("Error creating WS batch.", error);

        notify({
          title: "Erro:",
          message: "Erro ao tentar criar novo lote.",
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.batch-samples {
  font-family: 'Exo 2', sans-serif;
}

.batches-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  &-item {
    cursor: pointer;
  }

  &-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;

    &-icon {
      width: 95px;
      height: 87px;
    }

    &-text {
      font-family: Roboto;
      font-weight: 400;
      font-size: 1rem;
      text-align: center;
      color: #666666;
      max-width: 294px;
    }
  }
}

.batches-modal {
  max-height: 400px;
}
</style>
